/* eslint-disable react/prop-types */
import React from 'react';
import { Ad } from 'Components/atoms/Ad';

export const getNativeAd = ({
  targeting = {},
  label = '',
  renderWhenViewable = true,
  isNoBackground = true,
  extraClassNames = {},
  id = 'native_ad',
}) => (
  <Ad
    extraClassNames={extraClassNames}
    id={id}
    isNative
    isNoBackground={isNoBackground}
    label={label}
    renderWhenViewable={renderWhenViewable}
    targeting={targeting}
    type="native"
  />
);
